<template>
  <div class="container">
    <mt-header fixed title="合同附件" class="head" >
      <router-link to="/contract" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
    <div class="content c_m_t_10">
      <div class="bg_white files c_box">
        <!--<iframe :src="url" style="height:80vh" width='100%'   frameborder="0" scrolling="no"></iframe>-->
        <iframe :src="pdfSrc" style="height:80vh" frameborder="0" width="100%" height="100%"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "contractFile",
    data:function () {
      return {
        pdfSrc: '', // pdf文件在服务器的路径，例如：http://192.168.1.2:8080/file/pdf/32c1881d-0371-6e0d-aa5c-7bdf3f223300.pdf
        serverIp: 'static/pdf/web/viewer.html?file=', // 服务器ip加端口，例如：http://192.168.1.2:8080/（这个是本地服务）
      }
    },
    mounted:function () {
      var url = this.$route.params.url||'';
      if(url){
        this.$indicator.open('加载中...');
        this.getPdf(url);
      }else{
        this.$router.push('/contract');
      }
    },
    methods: {
      getPdf(url){
        this.pdfSrc = this.serverIp+encodeURIComponent(url)
        this.$indicator.close();
      },
    }
  }
</script>

<style scoped>
  .group{
    width: 100%;
    overflow-x: auto;
    overflow-y:hidden ;
    white-space: nowrap;
    box-sizing: border-box;
  }
  .group .img{
    width: 25vw;
    height: 25vw;
    background: #ccc;
    display: inline-block;
  }
  .group .img img{
    width: 25vw;
    height: 25vw;
    display: inline-block;
  }
  .group .img_model {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.5);
    z-index: 10;
    color: #fff;
  }
  .content{
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .content>div{
    width: 100%;
    height: 100%;
  }
  .content img{
    width: 100%;
  }
  .files{
    width: 100vw;
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/contractFile.vue